import { Button } from 'react-bootstrap';
import { FaLine } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useRequestLinePayMutation } from '../slices/ordersApiSlice';

// Shown on OrderScreen when the order's paymentMethod is 'LinePay'.
// Step 1 of LINE Pay: ask our server to reserve the payment, then leave the
// site for LINE's payment page. LINE sends the user back to
// /order/:id/linepay/confirm (LinePayConfirmScreen) when they finish.
const LinePayButton = ({ orderId }) => {
  const [requestLinePay, { isLoading }] = useRequestLinePayMutation();

  const clickHandler = async () => {
    try {
      const { paymentUrl } = await requestLinePay(orderId).unwrap();
      window.location.assign(paymentUrl);
    } catch (err) {
      toast.error(err?.data?.message || err.error || 'LINE Pay 暫時無法使用');
    }
  };

  return (
    <Button
      type="button"
      className="btn-line w-100"
      onClick={clickHandler}
      disabled={isLoading}
    >
      <FaLine aria-hidden="true" />
      {isLoading ? '前往 LINE Pay…' : '使用 LINE Pay 付款'}
    </Button>
  );
};

export default LinePayButton;
